module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEYSURBVHgBpVILFcIwDGynYBKKApAADoaDoYA5ABSAA3AwHEzCJBQHgIJweQuPEroP2713a5fPJW1jTARElIIFWIKePqjFlpuhQHAG3qkfvlcYAUf6H7s2sR2Nx1GL5TQdGWtZEfRYnJmGBziLdVeBy75sjpHYEAU7SmV04IXaLrsR24pYqnKviT6qtfYG5tg+qRkNFwhxsbIJsyvwoWrNjapAqpOFiPK1vOczUzFfSDqO5bCcwTW4AJey34ZdxxK97lCOVnGHsULic5EO67ZHqbq6CGNU7pWdhTJ2ikVEQ+QWnxR+HuzUTANPxyyRp9+Y6Th8/aHTE43HPlqCHfQ/TqYL1AyxHyD0M+RDhHmk6kDEi40nI/qIL6LJHitDOwZvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/Email.png
// module id = Ojr1
// module chunks = 0